<template>
  <div>
    <v-list-tile :class="itemPadding">
      <v-layout row align-center class="caption" wrap :class="paddingClass">
        <v-flex xs12 md3 :class="elPadding">
          <span class="font-weight-medium hidden-md-and-up">Numer faktury:<br/></span>
          {{subscription.invoice_number}}
        </v-flex>
        <v-flex xs12 md3 :class="elPadding">
          <span class="font-weight-medium hidden-md-and-up">Okres rozliczenia:<br/></span>
          {{subscription.date_from}} - {{subscription.date_to}}
        </v-flex>
        <v-flex xs12 md2 :class="elPadding">
          <span class="font-weight-medium hidden-md-and-up">Zapłacone:<br/></span>
          {{subscription.is_paid_txt}}
        </v-flex>
        <v-flex xs12 sm5 md3 lg3 :class="elPadding">
          <span class="font-weight-medium hidden-md-and-up">Dostępne miejsce:<br/></span>
          <v-layout align-center>
            <v-flex xs4 lg4 md5>
              {{availableSpaceTxt}}GB z
              {{subscription.space_available}}GB
            </v-flex>
            <v-flex xs8 pl-2>
              <v-progress-linear
                :color="usageColor"
                height="5"
                v-model="availableSpace"
              ></v-progress-linear>
            </v-flex>
          </v-layout>
        </v-flex>
        <SubscriptionMenu :subscriptionId="subscription.id" />
      </v-layout>
    </v-list-tile>
    <v-divider v-if="!isLast"></v-divider>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SubscriptionMenu from './SubscriptionMenu.vue';

export default {
  name: 'subscriptions-item',
  components: {
    SubscriptionMenu,
  },
  props: ['subscription', 'index'],
  computed: {
    ...mapGetters('subscriptions', [
      'subscriptionsList',
    ]),
    paddingClass() {
      return this.$vuetify.breakpoint.smAndDown ? 'px-0' : 'px-2';
    },
    itemPadding() {
      return this.$vuetify.breakpoint.smAndDown ? 'py-3' : 'py-0';
    },
    elPadding() {
      return this.$vuetify.breakpoint.smAndDown ? 'pb-2' : '';
    },
    availableSpaceTxt() {
      return this.subscription.space_available - this.subscription.space_used;
    },
    availableSpace() {
      const max = this.subscription.space_available;
      const currentUseage = this.subscription.space_used;
      return 100 - ((currentUseage * 100) / max);
    },
    isLast() {
      return this.subscriptionsList.length - 1 === this.index;
    },
    usageColor() {
      if (this.availableSpace < 10) {
        return 'red darken-2';
      }
      if (this.availableSpace >= 10 && this.availableSpace < 50) {
        return 'orange darken-4';
      }
      if (this.availableSpace >= 50 && this.availableSpace < 75) {
        return 'green';
      }
      return 'primary';
    },
  },
};
</script>
